export default {
    CZ: {
        'pmatch': 'zadaná hesla nejsou stejná',
        'plen': 'minimální délka hesla je 10 znaků',
        'pchar': 'heslo musí obsahovat alespoň jedno písmeno',
        'pdigit': 'heslo musí obsahovat alespoň jednu číslici',
        'usernameInfo': 'vaše uživatelské jméno je',
        'emailInfo': 'vaše e-mailová adresa je'
    },
    EN: {
        'pmatch': 'passwords don\'t match',
        'plen': 'minimal password length is 10 characters',
        'pchar': 'password must contain at last one letter',
        'pdigit': 'password must contain at last one digit',
        'usernameInfo': 'your username is',
        'emailInfo': 'your email is'
    }
};
